import React, { useState, useEffect } from "react";
import moment from "moment";
import { downArrow } from "../assets/icons";
import { ImgIcon } from "../assets";
import { splitTime } from "../helpers"

export default function TimeSelector({ onChange, value, openingTimes, minTime = 40 }) {

    const [date, setDate] = useState(moment(value || undefined));

    useEffect(() => {
        setDate(moment(value || undefined))
    }, [value])

    const isToday = date.isSame(moment(), 'day');
    const times = openingTimes
        .filter(time => {
            let to = splitTime(time.to);
            return time.day === date.format("ddd").toUpperCase() &&
                (isToday ? date.isSameOrBefore(date.clone().set({ hour: to[0], minute: to[1] })) : true)
        })
        .map(time => ({ from: splitTime(time.from), to: splitTime(time.to) }))


    function timesList() {
        let list = [];

        times.forEach(time => {

            let from = date.clone().set({ hour: time.from[0], minute: time.from[1] });
            let to = date.clone().set({ hour: time.to[0], minute: time.to[1] });

            while (from.isSameOrBefore(to)) {
                if (
                    (!isToday || from.isAfter(moment().add(minTime, "m"))) &&
                    !list.find(t => t.isSame(from))
                )
                    list.push(from.clone());
                from.add(10, 'minutes');
            }
        });

        return list;
    }

    return <div className="timeSelector noSelect">
        <div className="date">
            <div
                className={`arrow left ${isToday ? 'disabled' : ''}`}
                onClick={() => {
                    if (!isToday) setDate(date.clone().subtract(1, 'days'))
                }}
            >
                <ImgIcon
                    style={isToday ? { opacity: "0.2" } : {}}
                    cursor={isToday ? "initial" : "pointer"}
                    size={26}
                    src={downArrow}
                />

            </div>
            <div className="current-day featureFont upperCase">{isToday ? "Today" : date.format("ddd Do MMMM")}</div>
            <div
                className="arrow right"
                onClick={() => {
                    setDate(date.clone().add(1, 'day'))
                }}
            >
                <ImgIcon
                    cursor="pointer"
                    size={26}
                    src={downArrow}
                />
            </div>
        </div>
        <div className="times">
            {times.length
                ?
                <>
                    {isToday && <div onClick={() => onChange(null)} className={`slot ${value === null ? 'selected' : ''}`}>
                        <span>ASAP</span>
                        <span className="circle"></span>
                    </div>}
                    {timesList().map(time => {
                        const display = time.format("HH:mm");
                        return <div
                            key={display}
                            onClick={() => {
                                setDate(time.clone());
                                onChange(time.clone());
                            }}
                            className={`slot ${date.isSame(time) ? 'selected' : ''}`}
                        >
                            <span>{display}</span>
                            <span className="circle"></span>
                        </div>
                    })}
                </>
                : <div className="closed">Nothing available today</div>
            }
        </div>
    </div >
}
